import React, { Component } from 'react';

import Grid from 'components/Grid'
// import GridItem from 'components/GridItem'
import Flex from 'shared/Flex'
import FlexItem from 'shared/FlexItem'
import Img from 'shared/Img'
import ImgWrapper from 'components/ImgWrapper'
import Overlay from 'components/Overlay'
import Next from 'components/Next'
import Under from 'components/Under'
import X from 'components/X'

class Season extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeSrc: null,
      activeIdx: 0,
      images: [...Array(this.props.count+1).keys()].slice(1).map(k => (`https://s3.amazonaws.com/aez-project/barragan/${this.props.season}/${this.props.season}_${k.toString().padStart(2).replace(' ', '0')}.jpg`)),
      refresh: false
    }
  }

  componentWillUpdate(newProps) {
    if (newProps.active != this.props.active && newProps.active == false) {
      this.setState({
        activeSrc: null,
        activeIdx: 0
      })
    }
  }

  componentWillReceiveProps(newProps) {

    if (newProps.activeSeason != this.props.activeSeason) {
      if (newProps.activeSeason != this.props.season && this.state.activeSrc != null) {
        // if the newly updated active season is not this season, be sure to close any large image
        this.setState({
          activeSrc: null,
          activeIdx: null
        })
      }
    }
  }

  onClick = (src, i) => {
    this.props.activeSeason != this.props.season && this.props.setActiveSeason(this.props.season)

    if (this.state.activeSrc != src) {
      this.setState({
        activeSrc: src,
        activeIdx: i
      })
    }

    window.setTimeout(() => {
      window.location.href = "#" + this.props.season
      this.props.small ? window.scrollTo(0, window.scrollY - 75) : window.scrollTo(0, window.scrollY - 10)
    }, 100)

  }

  nextImage = () => {
    let newIdx = this.state.activeIdx + 1 < this.state.images.length ? this.state.activeIdx + 1 : 0
    this.setState({
      activeSrc: this.state.images[newIdx],
      activeIdx: newIdx
    })
  }
  prevImage = () => {
    let newIdx = this.state.activeIdx == 0 ? this.state.images.length - 1 : this.state.activeIdx - 1
    this.setState({
      activeSrc: this.state.images[newIdx],
      activeIdx: newIdx
    })
  }
  render() {
    return (
        <Flex wrap={"true"} gutter={"true"} justifyContent="space-between">
            <FlexItem style={{display: this.state.activeSrc ? 'block' : 'none'}} cursor="true" aspect="160%" margin="0" flex="1 1 100%">
                <Img onClick={this.prevImage} style={{cursor: 'w-resize'}} src={this.state.activeSrc} alt={`${this.props.season} show photo`} cover minWidth="250px" />
                <Next onClick={this.nextImage}></Next>
                <Under onClick={() => this.onClick(null)}></Under>
                <X white={"true"} onClick={() => this.onClick(null)}></X>
            </FlexItem>

          {
            this.state.images.map((src, i) => (
              <FlexItem style={{cursor: 'pointer'}} onClick={() => this.onClick(src, i)} key={i} aspect="160%" flex="1 0 30%"><Img src={src} alt={`${this.props.season} show photo`} cover minWidth="250px" /><Overlay dots >{this.props.season}</Overlay></FlexItem>
            ))
          }
          {
            [...Array(5).keys()].map((k, i) => (
              <FlexItem key={`empty_${i}`} flex="1 0 30%" width="250px" noheight></FlexItem>
            ))
          }
        </Flex>
    );
  }
}

export default Season;



// WEBPACK FOOTER //
// ./src/containers/Season.js